import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import PBSDroppingUpdate from "../PBSDroppingUpdate/PBSDroppingUpdate";

const PBSDropping = () => {
    const [pbsDroppingCount, setPbsDroppingCount] = useState(0);

    const title = "PBS Dropping Confirmation";

    return (
        <div>
            <TabbedViewWithDateSelect
                tabs={[
                    {
                        label: "PBS Dropping",
                        title: "PBS Dropping",
                        count: pbsDroppingCount,
                        countColor: 'blue',
                        backgroundColor: 'blue',
                        component: PBSDroppingUpdate,
                        props: {
                            handleCountChange: setPbsDroppingCount,
                        },
                    },
                ]}
                pageTitle={title}
            />
        </div>
    );
};

export default PBSDropping;
